// base.module.ts
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {  ImageCropperModule } from 'ngx-image-cropper';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { FileUploadModule } from 'primeng/fileupload';
import { PanelModule } from 'primeng/panel';
import { FormsModule } from '@angular/forms';
import { AppImageCropperComponent } from 'src/app/common/image-cropper/image-cropper.component';
import { EmojiModule } from '@ctrl/ngx-emoji-mart/ngx-emoji';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { EmojiListComponent } from 'src/app/components/admin-level/emoji-list/emoji-list.component';
import { ChatgptDialogComponent } from 'src/app/common/chatgpt-dialog/chatgpt-dialog.component';
import { StripePaymentPlanComponent } from 'src/app/common/stripe-payment-plan/stripe-payment-plan.component';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { ShowMoreSidePanelComponent } from 'src/app/components/artist-components/show-more-sidepanel/show-more-side-panel.component';
import { TableModule } from 'primeng/table';
import { SidebarModule } from 'primeng/sidebar';
import { ProductShareDailogComponent } from 'src/app/common/product-share/product-share.component';
import { TranslocoModule } from '@jsverse/transloco';

@NgModule({
  declarations: [
    AppImageCropperComponent,
    EmojiListComponent,
    ShowMoreSidePanelComponent,
    ChatgptDialogComponent,
    StripePaymentPlanComponent,
  ],
  exports: [
    AppImageCropperComponent,
    EmojiListComponent,
    ShowMoreSidePanelComponent,
    ChatgptDialogComponent,
    StripePaymentPlanComponent,
  ],
  imports: [
    CommonModule,PanelModule,TableModule,SidebarModule,
    FormsModule,EmojiModule,PickerModule,CheckboxModule,DropdownModule,
    FileUploadModule,ButtonModule,ImageCropperModule,DialogModule,
    TranslocoModule,
  ],
})
export class BaseModule { }
